import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { Avatar, Button, ListItem, ListItemAvatar, ListItemText, Typography, } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import Event from 'console/tabs/legacy/event';
import { openMiniMap } from 'widgets/map.corner/model/actions';
import { setPeriod } from 'console/period/actions';
import { preventDefault, useBatchActions, useCallbacks, usePartial, } from 'shared/hooks/utils';
import { changeTab, markAllEventsAsRead, pickDevice, showEventOnMap, } from 'console/redux/main-actions';
import { setScrollRandom } from 'console/sortableDeviceTree/redux/scrollRandom/scroll-random-actions';
import { dayEndToUnix, dayStartToUnix, todayEndToUnix, todayStartToUnix, } from 'webui/utils/unixtime';
import { dateTimeInPast, rusTimeDateLikeAPlus } from 'webui/utils/time';
import { useAction } from 'shared/hooks/redux/hooks';
export function onNewEvent(event, device_name) {
    return new Event({
        ...event,
        details: `<div class='infobox-tooltip' >
                                <img src="${window.ZONT_URL.api_event_icon}?type=${event.icon}" alt="${event.title}"/>
                                <span>${event.title}</span></br>
                              </div>`,
        time: 0,
        title: rusTimeDateLikeAPlus(new Date(event.time * 1e3)),
        device_name,
    });
}
export const ImportantEvent = memo(function ImportantEvents(props) {
    const { unread, device_name, event, hasGps, close } = props;
    const { x, y, device_id, time } = event;
    const dev_id = device_id ?? -1;
    const theme = useTheme();
    const newEvent = onNewEvent(event, device_name);
    const onOpenMiniMap = useCallbacks([
        preventDefault,
        usePartial(useAction(openMiniMap), dev_id),
        close,
    ]);
    const onClickEvent = useBatchActions([
        markAllEventsAsRead,
        usePartial(pickDevice, dev_id),
        usePartial(changeTab, 'eventsTab'),
        usePartial(setPeriod, dayStartToUnix(new Date(time * 1e3)) ?? todayStartToUnix(), dayEndToUnix(new Date(time * 1e3)) ?? todayEndToUnix()),
        usePartial(setScrollRandom, Math.random()),
        close,
    ]);
    const onShowGpsEvent = useBatchActions([
        usePartial(showEventOnMap, newEvent),
        usePartial(pickDevice, dev_id),
        markAllEventsAsRead,
        close,
    ]);
    const onClickHandler = useCallback(() => {
        if (x !== null && y !== null) {
            onShowGpsEvent();
            return;
        }
        onClickEvent();
    }, [onShowGpsEvent, onClickEvent, x, y]);
    return (_jsxs(ListItem, { onClick: onClickHandler, sx: { borderRadius: 1, width: 'auto', padding: '4px 8px' }, children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, { sx: {
                        filter: unread
                            ? 'invert(25%) sepia(73%) saturate(2201%) hue-rotate(344deg) brightness(96%) contrast(87%)'
                            : theme.palette.mode === 'dark'
                                ? 'invert(99%) sepia(41%) saturate(2%) hue-rotate(252deg) brightness(106%) contrast(101%)'
                                : '',
                        '& img': {
                            width: '75%',
                            height: '75%',
                        },
                    }, variant: "square", src: `${window.ZONT_URL.api_event_icon}?type=${event.icon}`, alt: event.title }) }), _jsx(ListItemText, { primaryTypographyProps: {
                    sx: {
                        color: 'rgb(60, 186,175, 1)',
                        fontSize: '13px',
                        textTransform: 'uppercase',
                    },
                }, primary: `${dateTimeInPast(new Date(event.time * 1e3), {
                    withSeconds: true,
                })} | ${device_name}`, secondary: _jsxs(Typography, { sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }, children: [_jsx(Typography, { component: "span", color: unread ? 'error' : 'textPrimary', variant: "body2", children: event.title }), _jsx(Typography, { component: "span", variant: "caption", sx: {
                                whiteSpace: 'pre-wrap',
                                color: 'grey',
                            }, children: event.details }), isMediumUI() && hasGps && unread && (_jsx(Button, { size: "small", color: "primary", onClick: onOpenMiniMap, sx: {
                                position: 'relative',
                                left: '-5px',
                                borderRadius: '5px',
                            }, children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u0438\u043D\u0438-\u043A\u0430\u0440\u0442\u0443" }))] }) })] }));
});
